// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Shinjin — 신진엠텍 CBL 화면 공통
   회차 화면(/shinjin/day1 ~ day6)의 상단 바 · 문서 · 기록지와
   팀별 에이전트 배포 화면(/shinjin/team1 · team2)을 담는다.
   ============================================================ */

.prompt.sj-page {
  --sj-navy: #13314f;
  --sj-ink: #0e1b2b;
  --sj-line: rgba(14, 27, 43, 0.12);
  min-height: 100vh;
  background: #eef0f5;
  color: var(--fg-text-basic);
  padding-bottom: 80px;
}

/* ───────── 상단 바 ───────── */
.sj-bar {
  position: sticky;
  top: 0;
  z-index: 10;
  background: var(--sj-navy);
  color: #fff;
}
.sj-bar__inner {
  max-width: 1320px;
  margin: 0 auto;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}
.sj-bar__brand {
  flex: none;
  display: flex;
  align-items: center;
  padding-right: 20px;
  border-right: 1px solid rgba(255, 255, 255, 0.18);
}
.sj-bar__brand img { display: block; height: 28px; width: auto; }
.sj-bar__text { flex: 1 1; min-width: 0; }
.sj-bar__eyebrow {
  margin: 0 0 4px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: rgba(255, 255, 255, 0.66);
}
.sj-bar__title {
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  letter-spacing: -0.01em;
  color: #fff;
}
.sj-bar__title-dim {
  font-weight: 500;
  color: rgba(255, 255, 255, 0.78);
}
.sj-bar__right {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex: none;
}
.sj-bar__verdict {
  font-size: 13px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.92);
  background: rgba(255, 255, 255, 0.14);
  border-radius: 999px;
  padding: 5px 12px;
  white-space: nowrap;
}
.sj-bar__teams {
  display: inline-flex;
  gap: 4px;
  padding: 3px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}
.sj-bar__team {
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.78);
  text-decoration: none;
  transition: background 0.15s ease, color 0.15s ease;
}
.sj-bar__team:hover { background: rgba(255, 255, 255, 0.12); color: #fff; }
.sj-bar__team--active { background: #fff; color: var(--sj-navy); }
.sj-bar__team--active:hover { background: #fff; color: var(--sj-navy); }

/* ───────── 본문 컨테이너 ───────── */
.sj-wrap {
  max-width: 1320px;
  margin: 0 auto;
  padding: 24px 24px 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.sj-empty {
  margin: 80px 0;
  text-align: center;
  color: var(--fg-text-gray);
}

/* ───────── 팀별 에이전트 배포 화면 (/shinjin/team1 · team2) ─────────
   레이아웃 · 말풍선은 AgentSharePage.css 의 agent-share 를 쓰고, 여기서는 무채색 + 남색으로 톤만 맞춘다. */
.agent-share.sj-bot {
  background: #f4f6f8;
}
.sj-bot__logo {
  display: block;
  height: 24px;
  width: auto;
}
.sj-bot__teams {
  display: inline-flex;
  gap: 2px;
  padding: 3px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
}
.sj-bot__team {
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-text-gray);
  text-decoration: none;
  transition: background 0.15s ease, color 0.15s ease;
}
.sj-bot__team:hover { color: var(--fg-text-basic); }
.sj-bot__team--active,
.sj-bot__team--active:hover { background: var(--agent-share-accent); color: #fff; }
.sj-bot__team-tag {
  margin-left: 8px;
  padding: 2px 8px;
  border: 1px solid var(--fg-line);
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  color: var(--fg-text-gray);
  vertical-align: 2px;
}

/* 첫 화면 인사 */
.sj-bot__greet {
  font-size: 16px;
  font-weight: 700;
  color: var(--fg-text-basic);
}
.sj-bot__welcome .sj-bot__scope {
  margin-top: 4px;
  font-size: 14px;
}

/* 예시 질문 — 첫 화면은 가운데, 대화 중에는 사용자 쪽(오른쪽)에 붙인다 */
.sj-bot__suggest {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}
.sj-bot__welcome .sj-bot__suggest {
  align-items: center;
  margin-top: 24px;
}
.sj-bot__suggest-label {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: var(--fg-text-gray);
}
.sj-bot__suggest-btn {
  max-width: min(80%, 560px);
  padding: 10px 14px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 14px;
  font-family: inherit;
  font-size: 14px;
  line-height: 22px;
  color: var(--fg-text-basic);
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.sj-bot__suggest-btn:hover {
  border-color: var(--agent-share-accent);
  background: #f6f7f9;
}

/* 준비되지 않은 입력에 대한 안내 말풍선 */
.sj-bot__notice { color: var(--fg-text-gray); }

/* 소개 카드 오른쪽 구성 보기 버튼 */
.sj-bot__config-btn { flex: none; }

/* ───────── 구성 보기 모달 — 셸은 Agent.css 의 workflow-modal, 본문만 여기서 ───────── */
.workflow-modal__dialog.sj-config { max-width: 880px; }
.workflow-modal__body.sj-config__body {
  gap: 24px;
  padding-top: 20px;
  padding-bottom: 28px;
}
.sj-config__overview {
  margin: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 24px;
  padding: 14px 16px;
  background: #f6f7f9;
  border-radius: 10px;
}
.sj-config__overview > div {
  display: flex;
  gap: 12px;
  min-width: 0;
  font-size: 13.5px;
  line-height: 1.55;
}
.sj-config__overview dt {
  flex: none;
  width: 56px;
  font-weight: 600;
  color: var(--fg-text-gray);
}
.sj-config__overview dd {
  margin: 0;
  color: var(--fg-text-basic);
}
.sj-config__section {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.sj-config__head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--fg-line);
}
.sj-config__title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: var(--fg-text-basic);
}
.sj-config__count {
  margin-left: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-text-gray);
  font-variant-numeric: tabular-nums;
}
.sj-config__note {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.6;
  color: var(--fg-text-gray);
}
.sj-config__prompt {
  margin: 0;
  max-height: 260px;
  overflow-y: auto;
  padding: 14px 16px;
  background: #f6f7f9;
  border-radius: 8px;
  font-family: inherit;
  font-size: 13px;
  line-height: 1.7;
  white-space: pre-wrap;
  color: var(--fg-text-basic);
}
.sj-config__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px 32px;
}
.sj-config__list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.sj-config__item {
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.sj-config__item-name {
  font-size: 13.5px;
  font-weight: 500;
  line-height: 1.5;
  color: var(--fg-text-basic);
}
.sj-config__item-sub {
  font-size: 12.5px;
  line-height: 1.5;
  color: var(--fg-text-gray);
}

/* ───────── 반응형 ───────── */
@media (max-width: 960px) {
  .sj-bar__inner {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  .sj-bar__brand { padding-right: 0; border-right: 0; }
}
@media (max-width: 640px) {
  .sj-wrap { padding: 16px 14px 0; }
  /* 구성 보기 버튼은 소개 문구 아래 줄로 */
  .agent-share.sj-bot .agent-share__hero { flex-wrap: wrap; }
  .agent-share.sj-bot .agent-share__hero-text { flex-basis: calc(100% - 58px); }
  .sj-bot__config-btn { margin-left: 58px; }
  .sj-config__overview,
  .sj-config__grid { grid-template-columns: 1fr; }
}

/* ───────── 회차별 진행 기록 문서 (/shinjin/day1 ~ day6) ─────────
   문서 본문은 public/shinjin-docs/*.html 을 iframe 으로 띄운다. 상단 바 아래를 꽉 채운다. */
.prompt.sj-page.sj-page--doc {
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  padding-bottom: 0;
}
.sj-page--doc .sj-bar { flex: none; }
.sj-doc__frame {
  flex: 1 1;
  width: 100%;
  min-height: 0;
  border: 0;
  background: #f4f6f8;
}

/* ───────── 기록지 폼 (ShinjinPracticeForm) — ① 회차 실습 · 결과 상세가 쓴다 ─────────
   무채색 + 남색 한 가지. 변수(--sjp-*)는 쓰는 쪽 래퍼(.sjl-worksheet)가 준다. */
.sjp-label { display: block; margin: 0 0 6px; font-size: 12.5px; font-weight: 600; color: var(--sjp-muted); }
.sjp-hint { margin: 0; font-size: 12.5px; line-height: 1.6; color: var(--sjp-muted); }
.sjp-step {
  padding: 24px;
  background: #fff;
  border: 1px solid var(--sjp-line);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  scroll-margin-top: 96px;
}
.sjp-step__head { display: flex; align-items: center; gap: 12px; }
.sjp-step__no {
  flex: none;
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border: 1px solid var(--sjp-ink);
  border-radius: 50%;
  font-size: 13px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}
.sjp-step__titles { flex: 1 1; min-width: 0; }
.sjp-step__title { margin: 0; font-size: 17px; font-weight: 700; letter-spacing: -0.01em; color: var(--sjp-ink); }
.sjp-step__time { margin: 2px 0 0; font-size: 12px; color: var(--sjp-muted); font-variant-numeric: tabular-nums; }
.sjp-step__goal { margin: 0; font-size: 14px; line-height: 1.7; max-width: 72ch; }
.sjp-tag {
  flex: none;
  padding: 3px 10px;
  border: 1px solid var(--sjp-line);
  border-radius: 999px;
  background: #fff;
  font-size: 12px;
  font-weight: 600;
  color: var(--sjp-muted);
  white-space: nowrap;
}
.sjp-tag--done { border-color: var(--sjp-ink); color: var(--sjp-ink); }
.sjp-fields { display: grid; grid-template-columns: 1fr 1fr; gap: 16px 20px; }
.sjp-field { min-width: 0; }
.sjp-field--wide { grid-column: 1 / -1; }
.sjp-input {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid var(--sjp-line);
  border-radius: 4px;
  background: #fff;
  font: inherit;
  font-size: 14px;
  line-height: 1.5;
  color: var(--sjp-ink);
}
.sjp-input--area { resize: vertical; min-height: 76px; }
.sjp-input:focus-visible { outline: 2px solid var(--sjp-ink); outline-offset: 0; border-color: var(--sjp-ink); }
.sjp-input:disabled { background: transparent; color: var(--sjp-muted); cursor: not-allowed; }
.sjp-value { margin: 0; font-size: 14px; line-height: 1.7; white-space: pre-wrap; }
.sjp-checks { display: flex; flex-direction: column; gap: 6px; }
.sjp-check { display: flex; align-items: flex-start; gap: 8px; font-size: 14px; line-height: 1.5; cursor: pointer; }
.sjp-check input { margin-top: 3px; accent-color: var(--sjp-ink); }
.sjp-checklist { margin: 0; padding: 0; list-style: none; display: flex; flex-direction: column; gap: 4px; font-size: 14px; line-height: 1.6; }
.sjp-checklist li { display: flex; gap: 8px; }
.sjp-checklist span { flex: none; width: 14px; font-weight: 700; }
.sjp-checklist__off { color: var(--sjp-muted); }
.sjp-table-wrap { overflow-x: auto; border: 1px solid var(--sjp-line); border-radius: 4px; }
.sjp-table { width: 100%; border-collapse: collapse; font-size: 13.5px; line-height: 1.55; }
.sjp-table th, .sjp-table td { padding: 8px 10px; text-align: left; vertical-align: top; border-top: 1px solid var(--sjp-line); }
.sjp-table thead th { border-top: 0; background: var(--sjp-soft); font-size: 12px; font-weight: 600; color: var(--sjp-muted); white-space: nowrap; }
.sjp-table tbody th { font-weight: 600; white-space: nowrap; font-variant-numeric: tabular-nums; }
.sjp-table td .sjp-input { min-width: 96px; padding: 6px 8px; font-size: 13.5px; }
.sjp-table__flag { font-weight: 700; text-decoration: underline; text-underline-offset: 3px; }
.sjp-preview pre {
  margin: 0;
  padding: 14px 16px;
  border: 1px solid var(--sjp-line);
  border-left: 3px solid var(--sjp-ink);
  border-radius: 0 4px 4px 0;
  background: var(--sjp-soft);
  font-family: inherit;
  font-size: 13.5px;
  line-height: 1.7;
  white-space: pre-wrap;
}

@media (max-width: 640px) {
  .sjp-fields { grid-template-columns: 1fr; }
  .sjp-step { padding: 18px 16px; }
}
`, "",{"version":3,"sources":["webpack://./src/css/Shinjin.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAEjE;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;AACnD;AACA,qBAAqB,cAAc,EAAE,YAAY,EAAE,WAAW,EAAE;AAChE,gBAAgB,SAAO,EAAE,YAAY,EAAE;AACvC;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,qCAAqC;EACrC,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,mDAAmD;AACrD;AACA,sBAAsB,qCAAqC,EAAE,WAAW,EAAE;AAC1E,wBAAwB,gBAAgB,EAAE,qBAAqB,EAAE;AACjE,8BAA8B,gBAAgB,EAAE,qBAAqB,EAAE;;AAEvE,gCAAgC;AAChC;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;+EAC+E;AAC/E;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,mDAAmD;AACrD;AACA,sBAAsB,2BAA2B,EAAE;AACnD;8BAC8B,qCAAqC,EAAE,WAAW,EAAE;AAClF;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;AACA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B,kBAAkB,0BAA0B,EAAE;;AAE9C,uBAAuB;AACvB,sBAAsB,UAAU,EAAE;;AAElC,0EAA0E;AAC1E,oCAAoC,gBAAgB,EAAE;AACtD;EACE,SAAS;EACT,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,uCAAuC;AACzC;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;EACA,iBAAiB,gBAAgB,EAAE,eAAe,EAAE;AACtD;AACA;EACE,WAAW,oBAAoB,EAAE;EACjC,0BAA0B;EAC1B,yCAAyC,eAAe,EAAE;EAC1D,8CAA8C,6BAA6B,EAAE;EAC7E,sBAAsB,iBAAiB,EAAE;EACzC;qBACmB,0BAA0B,EAAE;AACjD;;AAEA;uEACuE;AACvE;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;AACA,wBAAwB,UAAU,EAAE;AACpC;EACE,SAAO;EACP,WAAW;EACX,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;6DAC6D;AAC7D,aAAa,cAAc,EAAE,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAC5G,YAAY,SAAS,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AACrF;EACE,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;AACA,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AACjE;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;AACA,oBAAoB,SAAO,EAAE,YAAY,EAAE;AAC3C,mBAAmB,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,qBAAqB,EAAE;AACjH,kBAAkB,eAAe,EAAE,eAAe,EAAE,uBAAuB,EAAE,kCAAkC,EAAE;AACjH,kBAAkB,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACjF;EACE,UAAU;EACV,iBAAiB;EACjB,iCAAiC;EACjC,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA,iBAAiB,4BAA4B,EAAE,qBAAqB,EAAE;AACtE,cAAc,aAAa,EAAE,8BAA8B,EAAE,cAAc,EAAE;AAC7E,aAAa,YAAY,EAAE;AAC3B,mBAAmB,mBAAmB,EAAE;AACxC;EACE,WAAW;EACX,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA,mBAAmB,gBAAgB,EAAE,gBAAgB,EAAE;AACvD,2BAA2B,iCAAiC,EAAE,iBAAiB,EAAE,4BAA4B,EAAE;AAC/G,sBAAsB,uBAAuB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC7F,aAAa,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AAClF,cAAc,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC/D,aAAa,aAAa,EAAE,uBAAuB,EAAE,QAAQ,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACnH,mBAAmB,eAAe,EAAE,4BAA4B,EAAE;AAClE,iBAAiB,SAAS,EAAE,UAAU,EAAE,gBAAgB,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC9I,oBAAoB,aAAa,EAAE,QAAQ,EAAE;AAC7C,sBAAsB,UAAU,EAAE,WAAW,EAAE,gBAAgB,EAAE;AACjE,sBAAsB,uBAAuB,EAAE;AAC/C,kBAAkB,gBAAgB,EAAE,iCAAiC,EAAE,kBAAkB,EAAE;AAC3F,aAAa,WAAW,EAAE,yBAAyB,EAAE,iBAAiB,EAAE,iBAAiB,EAAE;AAC3F,+BAA+B,iBAAiB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,qCAAqC,EAAE;AAChI,sBAAsB,aAAa,EAAE,2BAA2B,EAAE,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACnJ,sBAAsB,gBAAgB,EAAE,mBAAmB,EAAE,kCAAkC,EAAE;AACjG,2BAA2B,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AACjF,mBAAmB,gBAAgB,EAAE,0BAA0B,EAAE,0BAA0B,EAAE;AAC7F;EACE,SAAS;EACT,kBAAkB;EAClB,iCAAiC;EACjC,qCAAqC;EACrC,0BAA0B;EAC1B,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc,0BAA0B,EAAE;EAC1C,YAAY,kBAAkB,EAAE;AAClC","sourcesContent":["/* ============================================================\n   Shinjin — 신진엠텍 CBL 화면 공통\n   회차 화면(/shinjin/day1 ~ day6)의 상단 바 · 문서 · 기록지와\n   팀별 에이전트 배포 화면(/shinjin/team1 · team2)을 담는다.\n   ============================================================ */\n\n.prompt.sj-page {\n  --sj-navy: #13314f;\n  --sj-ink: #0e1b2b;\n  --sj-line: rgba(14, 27, 43, 0.12);\n  min-height: 100vh;\n  background: #eef0f5;\n  color: var(--fg-text-basic);\n  padding-bottom: 80px;\n}\n\n/* ───────── 상단 바 ───────── */\n.sj-bar {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background: var(--sj-navy);\n  color: #fff;\n}\n.sj-bar__inner {\n  max-width: 1320px;\n  margin: 0 auto;\n  padding: 16px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n}\n.sj-bar__brand {\n  flex: none;\n  display: flex;\n  align-items: center;\n  padding-right: 20px;\n  border-right: 1px solid rgba(255, 255, 255, 0.18);\n}\n.sj-bar__brand img { display: block; height: 28px; width: auto; }\n.sj-bar__text { flex: 1; min-width: 0; }\n.sj-bar__eyebrow {\n  margin: 0 0 4px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  color: rgba(255, 255, 255, 0.66);\n}\n.sj-bar__title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  color: #fff;\n}\n.sj-bar__title-dim {\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.78);\n}\n.sj-bar__right {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  flex: none;\n}\n.sj-bar__verdict {\n  font-size: 13px;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.92);\n  background: rgba(255, 255, 255, 0.14);\n  border-radius: 999px;\n  padding: 5px 12px;\n  white-space: nowrap;\n}\n.sj-bar__teams {\n  display: inline-flex;\n  gap: 4px;\n  padding: 3px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n}\n.sj-bar__team {\n  padding: 6px 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.78);\n  text-decoration: none;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n.sj-bar__team:hover { background: rgba(255, 255, 255, 0.12); color: #fff; }\n.sj-bar__team--active { background: #fff; color: var(--sj-navy); }\n.sj-bar__team--active:hover { background: #fff; color: var(--sj-navy); }\n\n/* ───────── 본문 컨테이너 ───────── */\n.sj-wrap {\n  max-width: 1320px;\n  margin: 0 auto;\n  padding: 24px 24px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n.sj-empty {\n  margin: 80px 0;\n  text-align: center;\n  color: var(--fg-text-gray);\n}\n\n/* ───────── 팀별 에이전트 배포 화면 (/shinjin/team1 · team2) ─────────\n   레이아웃 · 말풍선은 AgentSharePage.css 의 agent-share 를 쓰고, 여기서는 무채색 + 남색으로 톤만 맞춘다. */\n.agent-share.sj-bot {\n  background: #f4f6f8;\n}\n.sj-bot__logo {\n  display: block;\n  height: 24px;\n  width: auto;\n}\n.sj-bot__teams {\n  display: inline-flex;\n  gap: 2px;\n  padding: 3px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n}\n.sj-bot__team {\n  padding: 4px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-text-gray);\n  text-decoration: none;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n.sj-bot__team:hover { color: var(--fg-text-basic); }\n.sj-bot__team--active,\n.sj-bot__team--active:hover { background: var(--agent-share-accent); color: #fff; }\n.sj-bot__team-tag {\n  margin-left: 8px;\n  padding: 2px 8px;\n  border: 1px solid var(--fg-line);\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--fg-text-gray);\n  vertical-align: 2px;\n}\n\n/* 첫 화면 인사 */\n.sj-bot__greet {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--fg-text-basic);\n}\n.sj-bot__welcome .sj-bot__scope {\n  margin-top: 4px;\n  font-size: 14px;\n}\n\n/* 예시 질문 — 첫 화면은 가운데, 대화 중에는 사용자 쪽(오른쪽)에 붙인다 */\n.sj-bot__suggest {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 6px;\n}\n.sj-bot__welcome .sj-bot__suggest {\n  align-items: center;\n  margin-top: 24px;\n}\n.sj-bot__suggest-label {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--fg-text-gray);\n}\n.sj-bot__suggest-btn {\n  max-width: min(80%, 560px);\n  padding: 10px 14px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 14px;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 22px;\n  color: var(--fg-text-basic);\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n.sj-bot__suggest-btn:hover {\n  border-color: var(--agent-share-accent);\n  background: #f6f7f9;\n}\n\n/* 준비되지 않은 입력에 대한 안내 말풍선 */\n.sj-bot__notice { color: var(--fg-text-gray); }\n\n/* 소개 카드 오른쪽 구성 보기 버튼 */\n.sj-bot__config-btn { flex: none; }\n\n/* ───────── 구성 보기 모달 — 셸은 Agent.css 의 workflow-modal, 본문만 여기서 ───────── */\n.workflow-modal__dialog.sj-config { max-width: 880px; }\n.workflow-modal__body.sj-config__body {\n  gap: 24px;\n  padding-top: 20px;\n  padding-bottom: 28px;\n}\n.sj-config__overview {\n  margin: 0;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px 24px;\n  padding: 14px 16px;\n  background: #f6f7f9;\n  border-radius: 10px;\n}\n.sj-config__overview > div {\n  display: flex;\n  gap: 12px;\n  min-width: 0;\n  font-size: 13.5px;\n  line-height: 1.55;\n}\n.sj-config__overview dt {\n  flex: none;\n  width: 56px;\n  font-weight: 600;\n  color: var(--fg-text-gray);\n}\n.sj-config__overview dd {\n  margin: 0;\n  color: var(--fg-text-basic);\n}\n.sj-config__section {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.sj-config__head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid var(--fg-line);\n}\n.sj-config__title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--fg-text-basic);\n}\n.sj-config__count {\n  margin-left: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-text-gray);\n  font-variant-numeric: tabular-nums;\n}\n.sj-config__note {\n  margin: 4px 0 0;\n  font-size: 12px;\n  line-height: 1.6;\n  color: var(--fg-text-gray);\n}\n.sj-config__prompt {\n  margin: 0;\n  max-height: 260px;\n  overflow-y: auto;\n  padding: 14px 16px;\n  background: #f6f7f9;\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 13px;\n  line-height: 1.7;\n  white-space: pre-wrap;\n  color: var(--fg-text-basic);\n}\n.sj-config__grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 24px 32px;\n}\n.sj-config__list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.sj-config__item {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n.sj-config__item-name {\n  font-size: 13.5px;\n  font-weight: 500;\n  line-height: 1.5;\n  color: var(--fg-text-basic);\n}\n.sj-config__item-sub {\n  font-size: 12.5px;\n  line-height: 1.5;\n  color: var(--fg-text-gray);\n}\n\n/* ───────── 반응형 ───────── */\n@media (max-width: 960px) {\n  .sj-bar__inner {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  .sj-bar__brand { padding-right: 0; border-right: 0; }\n}\n@media (max-width: 640px) {\n  .sj-wrap { padding: 16px 14px 0; }\n  /* 구성 보기 버튼은 소개 문구 아래 줄로 */\n  .agent-share.sj-bot .agent-share__hero { flex-wrap: wrap; }\n  .agent-share.sj-bot .agent-share__hero-text { flex-basis: calc(100% - 58px); }\n  .sj-bot__config-btn { margin-left: 58px; }\n  .sj-config__overview,\n  .sj-config__grid { grid-template-columns: 1fr; }\n}\n\n/* ───────── 회차별 진행 기록 문서 (/shinjin/day1 ~ day6) ─────────\n   문서 본문은 public/shinjin-docs/*.html 을 iframe 으로 띄운다. 상단 바 아래를 꽉 채운다. */\n.prompt.sj-page.sj-page--doc {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  height: 100dvh;\n  padding-bottom: 0;\n}\n.sj-page--doc .sj-bar { flex: none; }\n.sj-doc__frame {\n  flex: 1;\n  width: 100%;\n  min-height: 0;\n  border: 0;\n  background: #f4f6f8;\n}\n\n/* ───────── 기록지 폼 (ShinjinPracticeForm) — ① 회차 실습 · 결과 상세가 쓴다 ─────────\n   무채색 + 남색 한 가지. 변수(--sjp-*)는 쓰는 쪽 래퍼(.sjl-worksheet)가 준다. */\n.sjp-label { display: block; margin: 0 0 6px; font-size: 12.5px; font-weight: 600; color: var(--sjp-muted); }\n.sjp-hint { margin: 0; font-size: 12.5px; line-height: 1.6; color: var(--sjp-muted); }\n.sjp-step {\n  padding: 24px;\n  background: #fff;\n  border: 1px solid var(--sjp-line);\n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  scroll-margin-top: 96px;\n}\n.sjp-step__head { display: flex; align-items: center; gap: 12px; }\n.sjp-step__no {\n  flex: none;\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  border: 1px solid var(--sjp-ink);\n  border-radius: 50%;\n  font-size: 13px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n.sjp-step__titles { flex: 1; min-width: 0; }\n.sjp-step__title { margin: 0; font-size: 17px; font-weight: 700; letter-spacing: -0.01em; color: var(--sjp-ink); }\n.sjp-step__time { margin: 2px 0 0; font-size: 12px; color: var(--sjp-muted); font-variant-numeric: tabular-nums; }\n.sjp-step__goal { margin: 0; font-size: 14px; line-height: 1.7; max-width: 72ch; }\n.sjp-tag {\n  flex: none;\n  padding: 3px 10px;\n  border: 1px solid var(--sjp-line);\n  border-radius: 999px;\n  background: #fff;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--sjp-muted);\n  white-space: nowrap;\n}\n.sjp-tag--done { border-color: var(--sjp-ink); color: var(--sjp-ink); }\n.sjp-fields { display: grid; grid-template-columns: 1fr 1fr; gap: 16px 20px; }\n.sjp-field { min-width: 0; }\n.sjp-field--wide { grid-column: 1 / -1; }\n.sjp-input {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid var(--sjp-line);\n  border-radius: 4px;\n  background: #fff;\n  font: inherit;\n  font-size: 14px;\n  line-height: 1.5;\n  color: var(--sjp-ink);\n}\n.sjp-input--area { resize: vertical; min-height: 76px; }\n.sjp-input:focus-visible { outline: 2px solid var(--sjp-ink); outline-offset: 0; border-color: var(--sjp-ink); }\n.sjp-input:disabled { background: transparent; color: var(--sjp-muted); cursor: not-allowed; }\n.sjp-value { margin: 0; font-size: 14px; line-height: 1.7; white-space: pre-wrap; }\n.sjp-checks { display: flex; flex-direction: column; gap: 6px; }\n.sjp-check { display: flex; align-items: flex-start; gap: 8px; font-size: 14px; line-height: 1.5; cursor: pointer; }\n.sjp-check input { margin-top: 3px; accent-color: var(--sjp-ink); }\n.sjp-checklist { margin: 0; padding: 0; list-style: none; display: flex; flex-direction: column; gap: 4px; font-size: 14px; line-height: 1.6; }\n.sjp-checklist li { display: flex; gap: 8px; }\n.sjp-checklist span { flex: none; width: 14px; font-weight: 700; }\n.sjp-checklist__off { color: var(--sjp-muted); }\n.sjp-table-wrap { overflow-x: auto; border: 1px solid var(--sjp-line); border-radius: 4px; }\n.sjp-table { width: 100%; border-collapse: collapse; font-size: 13.5px; line-height: 1.55; }\n.sjp-table th, .sjp-table td { padding: 8px 10px; text-align: left; vertical-align: top; border-top: 1px solid var(--sjp-line); }\n.sjp-table thead th { border-top: 0; background: var(--sjp-soft); font-size: 12px; font-weight: 600; color: var(--sjp-muted); white-space: nowrap; }\n.sjp-table tbody th { font-weight: 600; white-space: nowrap; font-variant-numeric: tabular-nums; }\n.sjp-table td .sjp-input { min-width: 96px; padding: 6px 8px; font-size: 13.5px; }\n.sjp-table__flag { font-weight: 700; text-decoration: underline; text-underline-offset: 3px; }\n.sjp-preview pre {\n  margin: 0;\n  padding: 14px 16px;\n  border: 1px solid var(--sjp-line);\n  border-left: 3px solid var(--sjp-ink);\n  border-radius: 0 4px 4px 0;\n  background: var(--sjp-soft);\n  font-family: inherit;\n  font-size: 13.5px;\n  line-height: 1.7;\n  white-space: pre-wrap;\n}\n\n@media (max-width: 640px) {\n  .sjp-fields { grid-template-columns: 1fr; }\n  .sjp-step { padding: 18px 16px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
